import React from 'react';
import { Link } from '@hpstellar/core';

import withPageComponents from '../../../page/components/with-page-components';

const LINK_STYLES = {
    paddingLeft: '4px',
};

const CarePackMessage = ({
    productInitial,
    message = 'HP Care Packs are delivered electronically',
    ctaText = 'SEE DETAILS',
    ctaLink = 'https://www.hp.com/us-en/shop/cv/carepackfaq',
}) => {
    if (!productInitial || productInitial.carepacktype !== 'Electronic') {
        return null;
    }
    return (
        <div className="ecarepack-message">
            {message}
            <Link to={ctaLink} style={LINK_STYLES} target="_blank" rel="noopener noreferrer" dense>
                {ctaText}
            </Link>
        </div>
    );
};

export default withPageComponents(CarePackMessage, { components: ['productInitial'] });
